import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var titleBackButton = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_17mrnwq0',variantClassNames:{size:{xsmall:'fx_2d2fb1e5_17mrnwq1',small:'fx_2d2fb1e5_17mrnwq2','default':'fx_2d2fb1e5_17mrnwq3',large:'fx_2d2fb1e5_17mrnwq4'}},defaultVariants:{},compoundVariants:[]});
var titleBackButtonClickable = 'fx_2d2fb1e5_17mrnwq5';

export { titleBackButton, titleBackButtonClickable };
//# sourceMappingURL=backButton.vanilla.mjs.map
